// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oy-0";
export var buttonContainer = "_oy-3";
export var cancelButton = "_oy-4";
export var headerSection = "_oy-6";
export var headerTitle = "_oy-9";
export var messageSideLeft = "_oy-1";
export var messageSideRight = "_oy-2";
export var orderNumberContainer = "_oy-7";
export var orderNumberLabel = "_oy-8";
export var submitButton = "_oy-5";